import { SmartAuditRule } from "../../../../hooks/useSmartAuditRules/useSmartAuditRules.type";

export enum BaseFrequency {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
}

export enum DailyEndType {
    ON_THIS_DAY = 'on-this-day',
    NO_END_DATE = 'no-end-date',
    AFTER = 'after'
}

export enum DayOfTheWeek {
    SUNDAY = 'sunday',
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday'
}

export enum RecurrenceSubType {
    SPECIFIC_DAY = 'specific-day',
    DECLARATIVE_DAY = 'declarative-day'
}

export enum DeclarativeDayType {
    FIRST = 'first',
    SECOND = 'second',
    THIRD = 'third',
    FOURTH = 'fourth',
    LAST = 'last',
}

export enum DeclarativeDaysOfTheWeek {
    SUNDAY = 'Sun',
    MONDAY = 'Mon',
    TUESDAY = 'Tue',
    WEDNESDAY = 'Wed',
    THURSDAY = 'Thu',
    FRIDAY = 'Fri',
    SATURDAY = 'Sat',
    DAY = 'Day',
    WEEKDAY = 'Weekday',
    WEEKEND_DAY = 'WeekendDay'
}


export enum MonthsMapping {
    JANUARY = 1,
    FEBRUARY = 2,
    MARCH = 3,
    APRIL = 4,
    MAY = 5,
    JUNE = 6,
    JULY = 7,
    AUGUST = 8,
    SEPTEMBER = 9,
    OCTOBER = 10,
    NOVEMBER = 11,
    DECEMBER = 12,
}

export interface SmartAuditFrequencySubformProps {
    disabled: boolean,
    validationErrors: {[key: string]: string},
    incrementDecrementFunction: (...args: any) => void,
    customValueFunction: (...args: any) => void,
    editForm: SmartAuditRule | null,
    ruleEffectiveDate: Date,
}

export enum ItemValueType { 
    UNDER = 'under',
    OVER = 'over'
}

export enum RecurrenceType {
    DAILY = 1,
    WEEKLY = 2,
    MONTHLY = 3,
    YEARLY = 4,
}

export enum RecurrenceEndType {
    NO_END_DATE = 1,
    ON_END_DATE = 2,
    AFTER = 3,
    ON_THIS_DATE = 4,
}

export enum AuditRuleType {
    LOCATION = 1,
    CONNECTION = 2,
}

export enum ItemSelection {
    ALL_ASSIGNED_ITEMS = 1,
    ITEM_NOT_SCAN = 2,
    ITEM_TAG_WITH_CATEGORY = 3,
    ITEM_WITH_VALUES = 4,
}

export enum ValueComparisonType {
    UNDER = 1,
    OVER = 2,
}

export interface AuditRuleDaily {
    everyXDays: number
}

export interface AuditRuleWeeky {
    everyXWeeks: number,
    monday: boolean,
    tuesday: boolean,
    wednesday: boolean,
    thursday: boolean,
    friday: boolean,
    saturday: boolean,
    sunday: boolean,
}

export interface AuditRuleMonthly {
    everyXMonths: number,
    dayOfMonth: number,
    weekOfMonth: string,
    weekday: string,
}

export interface AuditRuleYearly {
    monthNumber: number,
    dayOfMonth: number,
    weekOfMonth: string,
    weekday: string,
}

// Used to control visibility of active section on form
export enum ActiveFormSegment {
    MAIN_DETAILS = 'main details',
    DATE_DETAILS = 'date details',
    ITEM_DETAILS = 'item details'
}

export interface SmartAuditRequestPayload {
    auditRuleID: number | null
    auditRuleName: string,
    auditRuleType: AuditRuleType,
    ruleEffectiveDate: string,
    numberOfDaysToComplete: number,
    closeAfterDueDate: boolean,
    isActive: boolean,
    recurrenceType: RecurrenceType,
    recurrenceEndType: RecurrenceEndType,
    recurrenceEndDate: string,
    auditRuleDaily: AuditRuleDaily | null,
    auditRuleWeekly: AuditRuleWeeky | null,
    auditRuleMonthly: AuditRuleMonthly | null,
    auditRuleYearly: AuditRuleYearly | null,
    locationIDs: number[] | string[],
    executionTimeZoneId: string,
    connectionIDs: string[],
    itemSelectionType: ItemSelection,
    categoryIDs: number[],
    valueComparisonType: ValueComparisonType,
    comparisonValue: number,
    notificationConnectionIDs: string[],
    notScannedDays: number | null
}

export interface FormInputValues {
    executionTimeZoneId: string,
    auditRuleName: string,
    auditRuleType: string,
    connectionIDs: string,
    ruleEffectiveDate: string,
    numberOfDaysToComplete: string,
    closeAfterDueDate: string,
    recurenceType: string,
    monthNumber: string,
    'Specific Day': string,
    dayOfMonth: string,
    weekOfMonth: string,
    weekday: string,
    recurrenceType: string,
    recurrenceEndType: string,
    itemSelectionType: string,
    categoryIDs: string,
    notificationConnectionIDs: string,
    everyXMonths: string,
    everyXDays: string,
    everyXWeeks: string,
    recurrenceEndDate: string,
    locationIDs: string
    comparisonValue: string,
    valueComparisonType: string,
    notScannedDays: string,
    monday: string;
    tuesday: string;
    wednesday: string;
    thursday: string;
    friday: string;
    saturday: string;
    sunday: string;
    recurrenceSubtype: RecurrenceSubType,
}